import type { LeadStatus } from '../types';

/** Shared icon tint for pipeline stages and follow-up urgency rows. */
export type StageIconVisual = { iconWrap: string; icon: string };

export const STAGE_ICON_VISUAL: Record<LeadStatus, StageIconVisual> = {
  to_contact: {
    iconWrap: 'bg-blue-50 ring-1 ring-inset ring-blue-100',
    icon: 'text-blue-500',
  },
  pending: {
    iconWrap: 'bg-amber-50 ring-1 ring-inset ring-amber-100',
    icon: 'text-amber-500',
  },
  negotiation: {
    iconWrap: 'bg-orange-50 ring-1 ring-inset ring-orange-100',
    icon: 'text-orange-500',
  },
  in_production: {
    iconWrap: 'bg-violet-50 ring-1 ring-inset ring-violet-100',
    icon: 'text-violet-500',
  },
  completed: {
    iconWrap: 'bg-emerald-50 ring-1 ring-inset ring-emerald-100',
    icon: 'text-emerald-500',
  },
  abandoned: {
    iconWrap: 'bg-rose-50 ring-1 ring-inset ring-rose-100',
    icon: 'text-rose-400',
  },
  rejected: {
    iconWrap: 'bg-red-50 ring-1 ring-inset ring-red-100',
    icon: 'text-red-500',
  },
};

export const STAGE_BAR_VISUAL: Record<LeadStatus, string> = {
  to_contact: 'bg-gradient-to-r from-blue-400 to-blue-500',
  pending: 'bg-gradient-to-r from-amber-400 to-amber-500',
  negotiation: 'bg-gradient-to-r from-orange-400 to-orange-500',
  in_production: 'bg-gradient-to-r from-violet-400 to-violet-500',
  completed: 'bg-gradient-to-r from-emerald-400 to-emerald-500',
  abandoned: 'bg-gradient-to-r from-rose-300 to-rose-400',
  rejected: 'bg-gradient-to-r from-red-400 to-red-500',
};

/** Follow-up badge variants reuse the same hues as adjacent pipeline stages. */
export type FollowUpUrgencyVariant = 'info' | 'orange-pastel' | 'danger';

export const FOLLOWUP_URGENCY_PIPELINE_STAGE: Record<FollowUpUrgencyVariant, LeadStatus> = {
  info: 'to_contact',
  'orange-pastel': 'negotiation',
  danger: 'rejected',
};

/** Badge pills — same bg/text/ring as the row icon circle. */
export function followUpUrgencyBadgeVisual(variant: FollowUpUrgencyVariant): string {
  const { iconWrap, icon } = STAGE_ICON_VISUAL[FOLLOWUP_URGENCY_PIPELINE_STAGE[variant]];
  return `${iconWrap} ${icon}`;
}
